import React from "react"
import PropTypes from "prop-types"

import Header from "./header"
import Footer from "./footer"

const Layout = ({ property, children }) => {
  return (
    <React.Fragment>
      <Header property={property} />
      <div className="my-3 container">{children}</div>
      <Footer property={property} />
    </React.Fragment>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
